import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { inject, NgModule, provideAppInitializer } from '@angular/core';
import { PreloadAllModules, RouterModule } from '@angular/router';
import { SharedComponentsLayoutModule } from '@lc/shared-components-layout';
import { SharedComponentsAuthModule } from '@lc/shared-components-auth';
import {
  AppService,
  CoreModule,
  DataDogLogger,
  initializeApp,
  LaunchDarklyService,
  StartupService,
  StateModule,
} from '@lc/core';
import { UserIdleConfig, UserIdleModule } from 'angular-user-idle';
import { SharedComponentsUiModule } from '@lc/shared-components-ui';
import { InputsModule, UILayoutModule } from '@lc/ui';
import { AppComponent } from './app.component';

if (location.hostname !== 'localhost' && location.hostname !== 'remotedev') {
  DataDogLogger.initialize('pub19b56e84527e84bc9c0e28fa98d7137a');
  DataDogLogger.initializeDDRealUserMonitoring('pub19b56e84527e84bc9c0e28fa98d7137a');
}

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    DragDropModule,
    CoreModule.forRoot(),
    StateModule,
    InputsModule,
    UILayoutModule,
    SharedComponentsAuthModule,
    SharedComponentsLayoutModule,
    SharedComponentsUiModule.forRoot(),
    RouterModule.forRoot([
      { path: '', loadChildren: () => import('@lc/suite-coord-app').then((m) => m.SuiteCoordAppModule) },
    ], {
      bindToComponentInputs: true,
      enableTracing: false,
      paramsInheritanceStrategy: 'always',
      preloadingStrategy: PreloadAllModules,
      scrollPositionRestoration: 'enabled',
    }),
    UserIdleModule,
  ],
  providers: [
    // User activity timeouts
    // Ping value is not used
    // Session timeout is pulled from AppSettings after load.  If not found default is 5 minutes
    { provide: UserIdleConfig, useFactory: () => ({ idle: AppService.get('sessionTimeout') * 60, timeout: 30, ping: 10000 }) },
    provideAppInitializer(() => {
      const initializerFn = (initializeApp)(inject(StartupService));
      return initializerFn();
    }),
    LaunchDarklyService,
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
